export default __webpack_public_path__ + "static/media/Snd_3_Starts.402d0b73.mp3";